import { v4 } from 'uuid';

export const fromPermission = (permission) =>
  (permission.decision === 'ALLOW' ? '' : '-') +
  [permission.domain, permission.subdomain, permission.action].filter((p) => !!p).join(':');

export const toPermission = (perm) => {
  let permission = perm;
  let decision = 'ALLOW';
  if (permission.startsWith('-')) {
    permission = permission.replace('-', '');
    decision = 'DENY';
  }
  const params = permission.split(':');
  const domain = params[0];
  const subdomain = params.length > 2 ? params[1] : undefined;
  const action = params.length >= 2 ? params[params.length - 1].toUpperCase() : undefined;
  return {
    domain,
    subdomain,
    action,
    decision,
  };
};

export const fromUser = (user) => ({
  uuid: v4(),
  userId: user.userId,
  permissions: (user.permissions || []).map(fromPermission),
  groups: user.groups || [],
});

export const fromUserFix = (user) => ({
  uuid: v4(),
  userId: user.name,
  permissions: (user.staticRules?.ruleSet || []).map(fromPermission),
  groups: (user.groups || []).map(({ name }) => name),
});

export const toUser = (user) => ({
  userId: user.userId,
  permissions: (user.permissions || []).map(toPermission),
  groups: user.groups || [],
});

export const fromGroup = (group) => ({
  uuid: v4(),
  groupId: group.groupId,
  permissions: (group.permissions || []).map(fromPermission),
});

export const fromGroupFix = (group) => ({
  uuid: v4(),
  groupId: group.name,
  permissions: (group.rules || []).map(fromPermission),
});

export const toGroup = (group) => ({
  groupId: group.groupId,
  permissions: (group.permissions || []).map(toPermission),
});
